import { useState } from 'react';
import { api, useAction } from '../../../api/hooks';
import { Button } from '../../../ui/Button';
import { Alert, ErrorAlert } from '../../../ui/feedback';
import { Field, Select, Textarea } from '../../../ui/forms';
import { Modal } from '../../../ui/Modal';
import type { AttemptDetail } from '../types';

export function ManualCheckDialog({
  a,
  name,
  base,
  onClose,
  inv,
}: {
  a: AttemptDetail;
  name: string;
  base: string;
  onClose: () => void;
  inv: unknown[][];
}) {
  const current = a.checks.find((c) => c.name === name);
  const [passed, setPassed] = useState(current?.passed ?? true);
  const [observation, setObservation] = useState(current?.observation ?? '');
  const remaining = a.binding.verificationChecks.filter(
    (c) => c !== name && !a.checks.some((r) => r.name === c),
  ).length;
  const m = useAction(
    () => api.post(`${base}/checks`, { expectedVersion: a.version, name, passed, observation }),
    { success: 'Check recorded', invalidate: inv as never, onSuccess: onClose },
  );
  return (
    <Modal
      title="Record manual check"
      onClose={onClose}
      actions={
        <>
          <Button variant="secondary" onClick={onClose}>
            Cancel
          </Button>
          <Button onClick={() => m.mutate(undefined)} loading={m.isPending} disabled={!observation.trim()}>
            Save
          </Button>
        </>
      }
    >
      <p>{name}</p>
      <Field label="Result">
        {(p) => (
          <Select {...p} value={String(passed)} onChange={(e) => setPassed(e.target.value === 'true')}>
            <option value="true">Passed</option>
            <option value="false">Failed</option>
          </Select>
        )}
      </Field>
      <Field label="What you observed">
        {(p) => (
          <Textarea {...p} rows={3} value={observation} onChange={(e) => setObservation(e.target.value)} />
        )}
      </Field>
      {remaining === 0 && (
        <Alert tone="info">
          This is the last missing check: saving finishes {a.attempt} as{' '}
          {passed && a.checks.every((c) => c.name === name || c.passed) ? 'succeeded' : 'failed'}.
        </Alert>
      )}
      <ErrorAlert error={m.error} />
    </Modal>
  );
}
